var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.ts)?[_c('span',{attrs:{"title":_vm.getFormattedTs(true)}},[_vm._v(_vm._s(_vm.getFormattedTs()))])]:[_c('span',{attrs:{"title":"-"}},[_vm._v(" - ")])]],2)}
var staticRenderFns = []

export { render, staticRenderFns }